module.exports = __webpack_public_path__ + "img/main2.125388bd.jpg";